import { connect } from 'react-redux';
import { ListItem, ListItemText } from '@mui/material';

const DrawerGroupHeader = ({ children, text, authLevel, userAuthLevel }) => {
  if (authLevel == null || userAuthLevel <= authLevel) {
    return (
      <ListItem key={text} style={{ padding: 0 }}>
        <ListItemText disableTypography className="nav-header">
          {text}
        </ListItemText>
        {children}
      </ListItem>
    );
  }
  return null;
};

export default connect(({ user: { userAuthLevel } }) => ({ userAuthLevel }))(DrawerGroupHeader);
